import { Coins, Users, Clock } from "lucide-react";
import { useCredits } from "@/hooks/useCredits";
import { useSubscription } from "@/hooks/useSubscription";
import { useDailyFreeUsage } from "@/hooks/useDailyFreeUsage";
import { Skeleton } from "@/components/ui/skeleton";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";

export const CreditsDisplay = () => {
  const { availableBalance, isUsingTeamCredits, teamName, loading: creditsLoading } = useCredits();
  const { currentPlan, loading: subLoading } = useSubscription();
  const { remaining, dailyLimit, isFreeUser, loading: dailyLoading } = useDailyFreeUsage();

  if (creditsLoading || subLoading || dailyLoading) {
    return <Skeleton className="h-8 w-20" />;
  }

  const isUnlimited = currentPlan?.credits === "unlimited";

  // Free users: show daily remaining
  if (isFreeUser) {
    return (
      <Tooltip>
        <TooltipTrigger asChild>
          <div className="flex items-center gap-1.5 px-3 py-1.5 bg-primary/10 border border-primary/20 rounded-full text-sm font-medium text-primary cursor-default">
            <Clock className="w-4 h-4" />
            <span>{remaining}/{dailyLimit}</span>
          </div>
        </TooltipTrigger>
        <TooltipContent>
          <p>
            {remaining > 0 ? `${remaining} analyse${remaining > 1 ? 's' : ''} gratuite${remaining > 1 ? 's' : ''} restante${remaining > 1 ? 's' : ''} aujourd'hui` : "Quota gratuit atteint aujourd'hui"}
          </p>
        </TooltipContent>
      </Tooltip>
    );
  }

  if (availableBalance === undefined) return null;

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <div className="flex items-center gap-1.5 px-3 py-1.5 bg-primary/10 border border-primary/20 rounded-full text-sm font-medium text-primary cursor-default">
          {isUsingTeamCredits ? (
            <Users className="w-4 h-4" />
          ) : (
            <Coins className="w-4 h-4" />
          )}
          <span>
            {isUnlimited ? "∞" : availableBalance}
          </span>
        </div>
      </TooltipTrigger>
      <TooltipContent>
        <p>
          {isUnlimited
            ? "Crédits illimités"
            : isUsingTeamCredits
            ? `${availableBalance} crédit${availableBalance !== 1 ? "s" : ""} (équipe ${teamName})`
            : `${availableBalance} crédit${availableBalance !== 1 ? "s" : ""} disponible${availableBalance !== 1 ? "s" : ""}`}
        </p>
      </TooltipContent>
    </Tooltip>
  );
};
